
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import MiezzMenuItem from "@/models/MiezzMenuItem";
export default class MiezzMenuItemComponent extends Vue {
  @Prop() model?: MiezzMenuItem;
}
